import styled from 'styled-components';
import StyledCheckbox from '../checkbox/StyledCheckbox';

interface TableHeaderProps {
  sortColumn: { path: string; order: 'ASC' | 'DESC' };
  checkBox: boolean;
  setSelectedRows: (rows: any[]) => void;
  selectedRows: any[];
  columns: any[];
  data: any[];
  handleSelectAll: (checked: boolean) => void;
  formListings?: boolean;
  type?: string;
}

const TableHeader = ({
  sortColumn,
  checkBox,
  setSelectedRows,
  selectedRows,
  columns,
  data,
  handleSelectAll,
  formListings,
  type = ''
}: TableHeaderProps) => {



  return (
    <THead className='bg-light'>
      <tr>
        {checkBox &&  (
          <th style={{ width: '15px', padding: '12px 16px' }} className='text-center fw-bold'>
            
            {!formListings &&<StyledTableCheck
              // className={`ms-2 mb-1 me-2`}
              size={15}
              value={selectedRows.length === data.length}
              onChange={(e:any) => handleSelectAll(e.target.checked)}
            />}
          </th>
        )}
        {columns?.map((column:any) => (
          <th
            style={{ width: column.width, padding: '12px 16px' }}
            className='text-center fw-bold'
            key={Math.random()}
          >
            <div className='d-flex justify-content-center align-items-center'>
              <span>{column.label}</span>
            </div>
          </th>
        ))}
      </tr>
    </THead>
  );
};

const THead = styled.thead`
  background-color: #f3f6f9 !important;
`

const StyledTableCheck = styled(StyledCheckbox)`
   margin: 8px;
   margin-bottom:10px;
   margin-top: 0px
`;

export default TableHeader;